(() => {
  const cache = new Map();
  const initialize = (nav) => {
    if (nav.dataset.inlineReady) return;
    const main = nav.closest('main');
    if (!main) return;
    const originals = [...new Set([...main.querySelectorAll('.collections-products, .zuqo-products, #ProductGridContainer')].map(node => node.closest('.shopify-section') || node))];
    if (!originals.length) return;
    nav.dataset.inlineReady = 'true';
    const slot = document.createElement('div');
    slot.hidden = true;
    originals[0].before(slot);
    const status = nav.querySelector('[data-zuqo-inline-status]');
    const all = nav.querySelector('[data-zuqo-inline-all]');
    let controller, sequence = 0, currentURL = null;
    const hiddenStates = originals.map(node => node.hidden);
    const select = (card) => {
      nav.querySelectorAll('[data-zuqo-inline-category]').forEach(node => {
        if (node === card) node.setAttribute('aria-current', 'true');
        else node.removeAttribute('aria-current');
      });
      all.setAttribute('aria-pressed', String(!card));
    };
    const load = async (href, card) => {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return false;
      url.searchParams.delete('view');
      url.searchParams.set('section_id', 'zuqo-inline-collection-products');
      const key = url.href;
      controller?.abort();
      controller = new AbortController();
      const ownSequence = ++sequence;
      status.textContent = status.dataset.loading;
      slot.setAttribute('aria-busy', 'true');
      try {
        let html = cache.get(key);
        if (!html) {
          const response = await fetch(key, { signal: controller.signal });
          if (!response.ok) throw new Error('Request failed');
          html = await response.text();
        }
        if (ownSequence !== sequence) return true;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const result = parsed.querySelector('[data-zuqo-inline-result]');
        if (!result) throw new Error('Missing products');
        result.querySelectorAll('script').forEach(node => node.remove());
        result.querySelectorAll('.scroll-trigger').forEach(node => node.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'));
        cache.set(key, html);
        if (cache.size > 12) cache.delete(cache.keys().next().value);
        slot.replaceChildren(result);
        slot.hidden = false;
        originals.forEach(node => { node.hidden = true; });
        currentURL = key;
        select(card);
        status.textContent = '';
      } catch (error) {
        if (ownSequence === sequence && error.name !== 'AbortError') status.textContent = status.dataset.error;
      } finally {
        if (ownSequence === sequence) slot.removeAttribute('aria-busy');
      }
      return true;
    };
    nav.addEventListener('click', event => {
      const card = event.target.closest('[data-zuqo-inline-category]');
      if (!card || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const url = new URL(card.href, location.href);
      if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return;
      event.preventDefault();
      load(card.href, card);
    });
    all.addEventListener('click', () => {
      ++sequence;
      controller?.abort();
      slot.hidden = true;
      slot.removeAttribute('aria-busy');
      originals.forEach((node, index) => { node.hidden = hiddenStates[index]; });
      status.textContent = '';
      select(null);
    });
    slot.addEventListener('click', event => {
      const link = event.target.closest('.zuqo-inline-products__pagination a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      const url = new URL(currentURL);
      const pageURL = new URL(link.href, currentURL);
      url.searchParams.set('page', pageURL.searchParams.get('page') || '1');
      load(url.href, nav.querySelector('[aria-current="true"]'));
    });
  };
  document.querySelectorAll('[data-zuqo-inline-collections]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-zuqo-inline-collections]').forEach(initialize));
  let pendingScroll = false;
  const updateScroll = () => {
    pendingScroll = false;
    const y = Math.max(0, window.scrollY);
    document.querySelectorAll('[data-zuqo-inline-collections]').forEach(nav => {
      const section = nav.closest('.shopify-section');
      if (!section) return;
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const sticky = section.getBoundingClientRect().top <= headerHeight + 2;
      if (y <= 8) section.classList.remove('is-scroll-hidden');
      else if (sticky && y > 80 && !(section.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))) section.classList.add('is-scroll-hidden');
    });
  };
  window.addEventListener('scroll', () => {
    if (pendingScroll) return;
    pendingScroll = true;
    requestAnimationFrame(updateScroll);
  }, { passive:true });
  document.addEventListener('focusin', event => {
    const nav = event.target.closest('[data-zuqo-inline-collections]');
    nav?.closest('.shopify-section')?.classList.remove('is-scroll-hidden');
  });

})();
